import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteHostDialog } from '#screens/hosts/delete/DeleteHostDialog.tsx';
import { DeleteLighthouseModal } from '#screens/lighthouses/delete/DeleteLighthouseModal.tsx';
import { DeleteRelayDialog } from '#screens/relays/delete/DeleteRelayDialog.tsx';
import styles from './HostActionMenu.module.css';

type Props = {
  hostId: string;
  isBlocked: boolean;
  isLighthouse: boolean;
  isRelay: boolean;
  isOIDCDevice: boolean;
};

export function HostActionMenu({ hostId, isBlocked, isLighthouse, isRelay, isOIDCDevice }: Props) {
  const location = useAppLocation();

  const [hostBeingDeletedId, setHostBeingDeletedId] = useState<string | null>(null);

  const blockedMenu = (
    <>
      <CopyIDMenuItem id={hostId} />
      <MenuItem render={<Link to={`${hostId}/edit`} state={{ from: location }} />}>Edit</MenuItem>
      <MenuItem onClick={() => setHostBeingDeletedId(hostId)}>Delete</MenuItem>
    </>
  );

  const menu = (
    <>
      <CopyIDMenuItem id={hostId} />
      {isOIDCDevice ? null : (
        <MenuItem render={<Link to={`${hostId}/enroll`} state={{ from: location }} />}>Enroll</MenuItem>
      )}
      <MenuItem render={<Link to={`${hostId}/debug`} state={{ from: location }} />}>Debug</MenuItem>
      <MenuItem render={<Link to={`${hostId}/edit`} state={{ from: location }} />}>Edit</MenuItem>
      <MenuItem onClick={() => setHostBeingDeletedId(hostId)}>Delete</MenuItem>
    </>
  );

  return (
    <>
      <MeatballMenu className={styles.HostActionMenu}>{isBlocked ? blockedMenu : menu}</MeatballMenu>
      {/* If there is a hostBeingDeletedId, show deletion modal */}
      {hostBeingDeletedId ?
        isLighthouse ?
          <DeleteLighthouseModal
            lighthouseId={hostBeingDeletedId}
            onCancel={() => {
              setHostBeingDeletedId(null);
            }}
            onDelete={() => {
              setHostBeingDeletedId(null);
            }}
          />
        : isRelay ?
          <DeleteRelayDialog
            relayId={hostBeingDeletedId}
            onCancel={() => {
              setHostBeingDeletedId(null);
            }}
            onDelete={() => {
              setHostBeingDeletedId(null);
            }}
          />
        : <DeleteHostDialog
            hostId={hostBeingDeletedId}
            onDelete={() => {
              setHostBeingDeletedId(null);
            }}
            onCancel={() => {
              setHostBeingDeletedId(null);
            }}
          />

      : null}
    </>
  );
}
